import { getLang } from 'mailup-react-helpers'
import help from '../documentation/help.json'
import { getEngagementDocumentationURL } from './ecommerce'

export const openHelp = (pageId) => {
  let lang = getLang()
  lang = lang === 'it' || lang === 'es' ? lang : 'en'
  return help?.[pageId]?.[lang] ?? ''
}

export const handleEngagementFiltersLearnMore = (locale) => {
    window.open(getEngagementDocumentationURL(locale), '_blank', 'noopener,noreferrer')
  }